const mallDomain = "/apps/mall";

async function fetchBase(url, func, method = 'GET', data = null, resolveUser = false) {
  try {
    // Use global customerId if available and encode as base64 
    // Purpose: Appending customerId as a base64 query parameter to the URL helps prevent cache issues by making the URL unique per customer.
    if (typeof customerId !== 'undefined' && customerId !== null) {
      const base64CustomerId = btoa(customerId);
      const separator = url.includes('?') ? '&' : '?';
      url = `${url}${separator}v=${base64CustomerId}`;
    }
    const options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'resolve-user': resolveUser.toString(),
        'cid': customerId
      }
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    const res = await fetch(url, options);

    //if (!res.ok) {
    //  throw new Error("データの取得に失敗しました");
    //}
    const responseData = await res.json();

    func(responseData);
  } catch (error) {
    //console.error("エラーが発生しました:", error);
  }
}
